import { render, staticRenderFns } from "./ModalExclusaoCompanyUnity.vue?vue&type=template&id=3731fd37&"
import script from "./ModalExclusaoCompanyUnity.vue?vue&type=script&lang=js&"
export * from "./ModalExclusaoCompanyUnity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports